// removed by extract-text-webpack-plugin
module.exports = {"footer":"style__footer___1gSyG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/countdown/style.css
// module id = 1006
// module chunks = 0